import React, { Component, PropTypes } from "react";
import "./example.less";

import Layout from "../layout/Layout";
import CenterLayout from "../layout/center/CenterLayout";
import CardLayout from "../layout/card/CardLayout";
import VtapeLayout from "../layout/tape/VtapeLayout";
import LeftLayout from "../layout/flow/LeftLayout";
import AbsoluteLayoutDemo from "./layout/demo.absoluteLayout";
import HorizontalCenterLayoutDemo from "./layout/demo.horizontalCenterLayout";
import VerticalCenterLayoutDemo from "./layout/demo.verticalCenterLayout";
import HorizontalAdaptLayoutDemo from "./layout/demo.horizontalAdaptLayout";
import VerticalAdaptLayoutDemo from "./layout/demo.verticalAdaptLayout";
import VtapeLayoutDemo from "./layout/demo.vtapelayout";
import LeftLayoutDemo from "./layout/demo.leftLayout";
import RightLayoutDemo from "./layout/demo.rightLayout";
import FillLayoutDemo from "./layout/demo.fillLayout";
import HtapeLayoutDemo from "./layout/demo.htapelayout";
import CenterLayoutDemo from "./layout/demo.centerLayout";
import HorizontalLayoutDemo from "./layout/demo.horizontalLayout";
import VerticalLayoutDemo from "./layout/demo.verticalLayout";
import CardLayoutDemo from "./layout/demo.cardLayout";
import BorderLayoutDemo from "./layout/demo.borderLayout";
import GridLayoutDemo from "./layout/demo.girdLayout";
import HorizontalLayout from "../layout/HorizontalLayout";
import HorizontalFillLayoutDemo from "./layout/demo.horizontalFillLayout";
import VerticalFillLayoutDemo from "./layout/demo.verticalFillLayout";

class App extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      defaultShowKey: "HorizontalLayoutDemo"
    };
  }

  _onClick(defaultShowKey) {
    this.setState({
      defaultShowKey
    });
  }

  render() {
    const { ...props } = this.props,
      { ...state } = this.state;
    return (
      <VtapeLayout
        style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }}
      >
        <VtapeLayout.Item
          height={50}
          style={{ borderBottom: "1px solid #ccc" }}
        >
          <HorizontalLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "AbsoluteLayoutDemo")}
              width={100}
              height={50}
            >
              绝对布局
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "HorizontalLayoutDemo")}
              width={100}
              height={50}
            >
              水平布局
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "VerticalLayoutDemo")}
              width={100}
              height={50}
            >
              垂直布局
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "CenterLayoutDemo")}
              width={100}
              height={50}
            >
              居中布局
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "HorizontalCenterLayoutDemo")}
              width={100}
              height={50}
            >
              水平居中
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "VerticalCenterLayoutDemo")}
              width={100}
              height={50}
            >
              垂直居中
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "HorizontalAdaptLayoutDemo")}
              width={100}
              height={50}
            >
              水平自适应
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "VerticalAdaptLayoutDemo")}
              width={100}
              height={50}
            >
              垂直自适应
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "HorizontalFillLayoutDemo")}
              width={100}
              height={50}
            >
              水平充满
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "VerticalFillLayoutDemo")}
              width={100}
              height={50}
            >
              垂直充满
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "FillLayoutDemo")}
              width={100}
              height={50}
            >
              充满
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "HtapeLayoutDemo")}
              width={100}
              height={50}
            >
              充满(水平)
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "VtapeLayoutDemo")}
              width={100}
              height={50}
            >
              充满(垂直)
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "GridLayoutDemo")}
              width={100}
              height={50}
            >
              网格
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "LeftLayoutDemo")}
              width={100}
              height={50}
            >
              左
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "RightLayoutDemo")}
              width={100}
              height={50}
            >
              右
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "CardLayoutDemo")}
              width={100}
              height={50}
            >
              card
            </CenterLayout>
            <CenterLayout
              onClick={this._onClick.bind(this, "BorderLayoutDemo")}
              width={100}
              height={50}
            >
              border
            </CenterLayout>
          </HorizontalLayout>
        </VtapeLayout.Item>
        <VtapeLayout.Item>
          <CardLayout defaultShowKey={state.defaultShowKey}>
            <AbsoluteLayoutDemo key="AbsoluteLayoutDemo" />
            <HorizontalLayoutDemo key="HorizontalLayoutDemo" />
            <VerticalLayoutDemo key="VerticalLayoutDemo" />
            <CenterLayoutDemo key="CenterLayoutDemo" />
            <HorizontalCenterLayoutDemo key="HorizontalCenterLayoutDemo" />
            <VerticalCenterLayoutDemo key="VerticalCenterLayoutDemo" />
            <HorizontalAdaptLayoutDemo key="HorizontalAdaptLayoutDemo" />
            <VerticalAdaptLayoutDemo key="VerticalAdaptLayoutDemo" />
            <HtapeLayoutDemo key="HtapeLayoutDemo" />
            <VtapeLayoutDemo key="VtapeLayoutDemo" />
            <FillLayoutDemo key="FillLayoutDemo" />
            <HorizontalFillLayoutDemo key="HorizontalFillLayoutDemo" />
            <VerticalFillLayoutDemo key="VerticalFillLayoutDemo" />
            <LeftLayoutDemo key="LeftLayoutDemo" />
            <RightLayoutDemo key="RightLayoutDemo" />
            <CardLayoutDemo key="CardLayoutDemo" />
            <BorderLayoutDemo key="BorderLayoutDemo" />
            <GridLayoutDemo key="GridLayoutDemo" />
          </CardLayout>
        </VtapeLayout.Item>
      </VtapeLayout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js